import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	EventBus
} from '@/support/event-bus';

import store from './store';

export default {
	...store,
	name: 'SchoolTheme',
	props: {
		label: {
			type: String,
			default: 'Disciplina'
		},
		selected: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		}
	},
	data: () => ({
		themeModel: ''
	}),
	computed: {
		...mapGetters({
			user: 'getLoggedUser',
			themes: 'themes'
		})
	},
	methods: {
		...mapActions([
			'getSchoolThemes',
			'setTheme'
		]),
		changed() {

			this.setTheme(this.themeModel);
			EventBus.$emit('themeSelected', this.themeModel);

		}
	},
	mounted() {

		this.getSchoolThemes(this.user);

	}
};



// WEBPACK FOOTER //
// ./sources/domains/school/theme/index.js